export const NETWORK_CONFIGS = {
  'mainnet-beta': {
    endpoint: 'https://p2p.rpcpool.com/82313b15169cb10f3ff230febb8d',
  },
};
